import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const MineIndex = lazy(() => import('./mine/Index'))
const Detail = lazy(() => import('./Detail'))

/**
 * Le dépôt d'un rapport est ouvert à tout collaborateur — « everybody within EAPC's operational and
 * technical environment » (SMM) : `role--safety--report` est porté par ROLE_USER et les rôles Safety,
 * pas par l'inspecteur (retouches 2 S11), que l'API refuse de toute façon.
 *
 * Ce sous-routeur est monté à la racine de l'application, hors du SafetyRouter qui est gardé par
 * `role--safety`. Même raison et même montage que communications/media-catalog.
 */
export const SafetyReportRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--report']}>
    <Route index element={<Index />} />
    <Route path='mine' element={<MineIndex />} />
    <Route path=':reportId' element={<Detail />} />
  </SubRouter>
))
